export default "__VITE_ASSET__WLNja829__"